import React from 'react'
import { Grid } from '@material-ui/core'
import { combine} from '../../../../utils'

// components
import { Biography, Contact, JobDetail, Name, Record } from './components'

import './summary.component.scss'

/**
 * Get Strategy By Factset Entity ID
 * @param id
 * @param strategy
 * @return {string|*}
 */
const getStrategy = (id, strategy) => {
  if (!id || !strategy) {
    return '-'
  }

  return (strategy || []).find((value) => value && value.factset_entity_id === id)
}

/**
 * Contact Detail Summary Component
 */
const ContactDetailSummary = (props) => {
  const { contact, strategy } = props
  const {
    id, source, status, salutation, firstName, lastName, nickName,
    directPhone, phoneExtension, mobile, email, jobs, bio
  } = contact

  return (
    <section className='contact-detail_summary'>
      <Grid container spacing={3}>

        <Grid item xs={6}>
          <Record
            id={id}
            source={source}
            status={status} />
        </Grid>
        <Grid item xs={6}>&nbsp;</Grid>

        <Grid item xs={6}>
          <Name
            name={combine([salutation, firstName, lastName], ' ')}
            nickName={nickName}/>
        </Grid>

        <Grid item xs={6}>
          <Contact
            directPhone={directPhone}
            phoneExtension={phoneExtension}
            mobile={mobile}
            email={email} />
        </Grid>

        {(jobs || []).map((job) => {
          return ((job && job._id)
            ? <JobDetail
              key={job._id}
              job={job}
              strategy={getStrategy(job.factset_entity_id, strategy)} />
            : null)
        })}

        <Grid item xs={6}>
          <Biography bio={bio} />
        </Grid>

      </Grid>
    </section>
  )
}

export default ContactDetailSummary
